"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var animateValues_1 = __importDefault(require("./animateValues"));
exports.default = (function () {
    var countableElements = Array.from(document.querySelectorAll('[data-countable]'));
    if (!countableElements || !window.IntersectionObserver) {
        return false;
    }
    var round = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    };
    var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var element_1 = entry.target;
                var _a = element_1.innerText.split('.'), decimals = _a[1];
                var precision_1 = decimals ? decimals.length : 0;
                var to = decimals ? parseFloat(element_1.innerText) : parseInt(element_1.innerText);
                var from = 0;
                observer.unobserve(element_1);
                element_1.innerText = '0';
                return animateValues_1.default([to, from], 5200, {
                    onUpdate: function (v) { return (element_1.innerText = round(v[1], precision_1).toString()); }
                });
            }
        });
    });
    countableElements.forEach(function (section) { return observer.observe(section); });
});
